import React from "react";
import LegalPage from "../../components/Legal/LegalPage.jsx";
import cookiePolicy from "./cookiePolicyData.js";

const CookiePolicy = () => <LegalPage policy={cookiePolicy} />;

export default CookiePolicy;
